<template>
    <div :class="{ frame: framed, 'my-5': framed }">
        <hr v-if="!framed" class="my-5 mx-auto" style="max-width: 200px" />
        <h2 class="text-center">{{ title }}</h2>
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: 'PartnersPageBlock',
        props: {
            title: {
                type: String,
                required: true,
            },
            framed: Boolean,
        },
    };
</script>
